import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { compose } from 'recompose';
import _property from 'lodash/property';
import _head from 'lodash/head';
import _map from 'lodash/map';
import _filter from 'lodash/filter';
import _includes from 'lodash/includes';
import _find from 'lodash/find';
import _reduce from 'lodash/reduce';
import _isEmpty from 'lodash/isEmpty';
import _omitBy from 'lodash/omitBy';
import _isNil from 'lodash/isNil';

// Constants
import { EMPTY_ARRAY, EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import { DEFAULT_FILTER_GROUP } from '../../../constants/filterSection.filterGroups';

// Helpers
import { getDefaultFilterTypes } from '../../../helpers/filterSection.defaultFilter';
import { getFiltersFromResponse } from '../../../helpers/filterSection.general';

// Factories
import getOperatorForFilterType from '../../../factory/filterDialog.operator';

// Readers
import filterTypeReader from '../../../readers/FilterType';
import filterGroupReader from '../../../readers/FilterGroup';
var getDefaultOperator = compose(_property('id'), _head, getOperatorForFilterType);
var findFilter = function findFilter(id, filters) {
  return _find(filters, function (_ref) {
    var type = _ref.type;
    return type === id;
  }) || EMPTY_OBJECT;
};
var mapFilterTypeToFilter = function mapFilterTypeToFilter() {
  var selectedFilters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_ARRAY;
  return function () {
    var filterType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
    var id = filterTypeReader.id(filterType);
    var _findFilter = findFilter(id, selectedFilters),
      _findFilter$values = _findFilter.values,
      values = _findFilter$values === void 0 ? null : _findFilter$values,
      _findFilter$additiona = _findFilter.additional,
      additional = _findFilter$additiona === void 0 ? EMPTY_OBJECT : _findFilter$additiona;
    var operator = getDefaultOperator(filterType);
    return {
      type: id,
      operator: operator,
      values: values,
      additional: additional
    };
  };
};
var isNotDefaultFilter = function isNotDefaultFilter(defaultIds) {
  return function (filter) {
    return !_includes(defaultIds, filter.id);
  };
};
var getFiltersWithoutDefaultFilters = function getFiltersWithoutDefaultFilters() {
  var filterTypes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  var defaultIds = arguments.length > 1 ? arguments[1] : undefined;
  return _filter(filterTypes, isNotDefaultFilter(defaultIds));
};
var getFiltersFromFilterTypes = function getFiltersFromFilterTypes(defaultIds, filterTypes, showDefaultFiltersInPopover, selectedFilters) {
  var defaultFilterTypes = showDefaultFiltersInPopover ? getDefaultFilterTypes(defaultIds, filterTypes) : getFiltersWithoutDefaultFilters(filterTypes, defaultIds);
  var filters = _map(defaultFilterTypes, mapFilterTypeToFilter(selectedFilters));
  return filters;
};
var appendExtraFiltersFromAPI = function appendExtraFiltersFromAPI(filtersFromFilterTypes, selectedFilters) {
  return _reduce(selectedFilters, function (acc, filter) {
    var type = filter.type,
      operator = filter.operator,
      values = filter.values,
      additional = filter.additional;
    if (_isEmpty(findFilter(type, filtersFromFilterTypes))) {
      acc.push({
        type: type,
        operator: operator,
        values: values,
        additional: additional
      });
    }
    return acc;
  }, _toConsumableArray(filtersFromFilterTypes));
};
export var getDefaultFilterGroup = function getDefaultFilterGroup(defaultIds, filterTypes, showDefaultFiltersInPopover, selectedFilters) {
  var filtersFromFilterTypes = getFiltersFromFilterTypes(defaultIds, filterTypes, showDefaultFiltersInPopover, selectedFilters);
  var filters = appendExtraFiltersFromAPI(filtersFromFilterTypes, selectedFilters);
  return {
    id: DEFAULT_FILTER_GROUP,
    name: __('Default Filter'),
    filters: filters
  };
};
export var getFilterGroupsForFilterSection = function getFilterGroupsForFilterSection(filterGroups) {
  return _map(filterGroups, function (group) {
    var extraFields = {
      defaultGroupIdentifier: filterGroupReader.defaultGroupIdentifier(group),
      nonRenamable: filterGroupReader.nonRenamable(group),
      nonDeletable: filterGroupReader.nonDeletable(group)
    };
    return _objectSpread({
      id: filterGroupReader.id(group),
      name: filterGroupReader.groupName(group),
      filters: getFiltersFromResponse(filterGroupReader.filters(group))
    }, _omitBy(extraFields, _isNil));
  });
};
export var getFilterGroups = function getFilterGroups() {
  var filterTypes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_ARRAY;
  var defaultFilterTypes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_ARRAY;
  var filterGroups = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_ARRAY;
  var showDefaultFiltersInPopover = arguments.length > 3 ? arguments[3] : undefined;
  var selectedFilters = arguments.length > 4 ? arguments[4] : undefined;
  var defaultFilterGroup = getDefaultFilterGroup(defaultFilterTypes, filterTypes, showDefaultFiltersInPopover, selectedFilters);
  return [defaultFilterGroup].concat(_toConsumableArray(getFilterGroupsForFilterSection(filterGroups)));
};